import { render, staticRenderFns } from "./summarize_view.vue?vue&type=template&id=3749ec32&scoped=true&"
import script from "./summarize_view.vue?vue&type=script&lang=js&"
export * from "./summarize_view.vue?vue&type=script&lang=js&"
import style0 from "./summarize_view.vue?vue&type=style&index=0&id=3749ec32&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3749ec32",
  null
  
)

export default component.exports